<div class="main_container">
    <div style="display:flex;margin: 10px;"><mat-icon>arrow_back</mat-icon>Posts</div>
    <div>
        <div style="display: inline-flex;margin: 10px;">
            <div class="profile_photo"><img src="/assets/box_icon.png" alt="profile"
                    style="height:25px;width: 25px;display: inline-block;margin-right: 20px;"></div>
            <div style="display: inline-block;">
                <div class="profile_name" style="font-family: var(--font);">SRAVAN</div>
                <div class="profile_location" style="font-family: var(--font);">Sharkify INC</div>
            </div>
        </div>
        <div class="posted_data">
            <img src="/assets/sai.jpg" alt="profile">
        </div>
        <div class="post_buttons">
            <div> <button><mat-icon>favorite</mat-icon></button></div>
            <div> <button><mat-icon>chat_bubble</mat-icon></button></div>
            <div> <button><mat-icon>send</mat-icon></button></div>
        </div>
        <div class="post_likes" style="font-family: var(--font);">Liked by</div>

        <div class="post_caption" style="font-family: var(--font);">SRAVAN</div>
        <div class="post_comments" style="font-family: var(--font);">View all commnets</div>
        <div class="post_date" style="font-family: var(--font);">Jan 9,2022</div>
    </div>
</div>